// @ts-nocheck
import { BlockParsedBaseProps } from "@store/Components/Toolkit/Block/Block";
import { BlockVariantBaseProps, BlockVariantTypeProps } from "@store/Components/Toolkit/Block/variant/base";
import { clearfixStyles } from "@store/Themes/common/mixins/common";
import { css } from "styled-components";

export interface BlockVariantBackgroundBaseProps {}
export interface BlockVariantBackgroundProps extends BlockVariantBaseProps, BlockVariantBackgroundBaseProps {}

const typeProps: BlockVariantTypeProps<BlockVariantBackgroundProps> = {
    defaultProps: {},
    staticProps: {
        containerCss: css<BlockParsedBaseProps>`
            ${clearfixStyles()}
        `,
    },
};

export default typeProps;
